<template>
  <FormPanel
      headline="Create Registration Category"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentRegistrationCategories/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-registration-categories', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The content registration category was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/registration-categories')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
